import { ICexPair } from 'types/pairs';

import { AApiBase } from '../apiBase/AApiBase';
import type { IBaseResponse } from '../apiBase/IBaseResponse';
import { mapError } from '../apiBase/mapError';
import { mapResponse } from '../apiBase/mapResponse';

class ApiCexPairs extends AApiBase {
  protected baseUrl = '/api';
  protected withHeader = true;

  private static __instance: ApiCexPairs | undefined;
  private static get instance(): ApiCexPairs {
    if (ApiCexPairs.__instance === undefined) {
      ApiCexPairs.__instance = new ApiCexPairs();
    }
    return ApiCexPairs.__instance;
  }

  /**
   * @deprecated Use `getCexPairById` from `entities/cex/api/pair` instead.
   */
  public static getCexPairById = async (id: number) => {
    try {
      const response = await ApiCexPairs.instance.get<IBaseResponse<ICexPair>>(`/cex-pairs/${id}`);

      return mapResponse({
        data: response.data,
      });
    } catch (error) {
      return mapError<ICexPair>({ error });
    }
  };

  public static updateCexPair = async ({ id, notes }: { id: number; notes: string }) => {
    try {
      const response = await ApiCexPairs.instance.patch<IBaseResponse<any>>(`/cex-pairs/${id}`, {
        notes,
      });

      return mapResponse({
        data: response.data,
      });
    } catch (error) {
      return mapError<any>({ error });
    }
  };

  public static deleteCexPair = async (id: number) => {
    try {
      const response = await ApiCexPairs.instance.delete<IBaseResponse<any>>(`/cex-pairs/${id}`);

      return mapResponse({
        data: response.data,
      });
    } catch (error) {
      return mapError<any>({ error });
    }
  };
}

export { ApiCexPairs };
